module.exports = __webpack_public_path__ + "static/nissi-f148159d99d4501c1a97373c8e43ecdb.jpg";